import { Injectable } from '@angular/core';
import { ApiService } from '@services/api.service';
import { Observable } from 'rxjs';
import { ManagementEntityEventModel } from '@data-layer/models/management';
import { environment } from '@env/environment';
import { CbpMessageModel } from '@data-layer/models/common';
import { EntryErrorModel } from '@data-layer/models/entry-summaries';

@Injectable({
  providedIn: 'root',
})
export class IsfMessagesRepository {
  constructor(private apiService: ApiService) {}

  public getCbpRawMessages(id: number, isShowLoader: boolean = true, isUsed: boolean = false): Observable<ManagementEntityEventModel[]> {
    return this.apiService.get(`${environment.url.isfs}${id}/raw-messages`, null, { isShowLoader, isUsed });
  }

  public getCBPMessages(id: number, isUsed: boolean = false): Observable<CbpMessageModel[]> {
    return this.apiService.get(`${environment.url.isfs}${id}/cbp-messages`, null, { isShowLoader: false, isUsed });
  }

  public getErrors(id: number, isShowLoader: boolean = true, isUsed: boolean = false): Observable<EntryErrorModel[]> {
    return this.apiService.get(`${environment.url.isfs}${id}/errors`, null, { isShowLoader, isUsed });
  }

  public getManagementCBPMessages(id: number, isUsed: boolean = false): Observable<ManagementEntityEventModel[]> {
    return this.apiService.get(`${environment.url.prefixCustoms}v2/management/isfs/${id}/messages`, null, {
      isShowLoader: false,
      isUsed,
    });
  }

  public getManagementErrors(id: number, isUsed: boolean = false): Observable<EntryErrorModel[]> {
    return this.apiService.get(`${environment.url.prefixCustoms}v2/management/isfs/${id}/errors`, null, {
      isShowLoader: false,
      isUsed,
    });
  }
}
